// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const MailIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="MailIcon" ref={forwardedRef} {...props}>
      <path d="M2 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm1.5 1.46v8.04h13V6.416l-6.498 5.57zM15.264 5.5H4.688l5.31 4.514z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const MailIcon = /* @__PURE__ */ Object.assign(MailIconComponent, {
  displayName: 'MailIcon',
});
